import {
  DateFilterType,
  PainelVendasFilterProps,
  CommercialOption,
} from "../../../../global/dataTransferObjects/transacoesTempoReal";
import axios from "axios";
import config from "../../../../config";
import { bffApi } from "../../../../services/bff/bffApi";
import { BaseService } from "../../../../global/classes";
import { createHTMLElement, downloadFile } from "../../../../utils/downloadFiles";
import { executeFluxDownload } from "../../shared/fluxDownload";
import { buildValueFilter } from "../../shared/valueFilter";
import { getDefaultDate } from "../utils";


export default class RecebiveisServices extends BaseService {

  private buildReceivablePayload(filter?: PainelVendasFilterProps, sortBy?: string) {
    const today = getDefaultDate();

    const saleInitDate   = filter?.initialDate    || today;
    const saleFinishDate = filter?.finalDate      || today;
    const initDate       = filter?.saleInitialDate || null;
    const finishDate     = filter?.saleFinalDate   || null;

    const isPaymentDateFilter = !!(initDate || finishDate);

    return {
      SortBy:       sortBy ?? 'desc',
      SaleInitDate:  isPaymentDateFilter ? null : saleInitDate,
      SaleFinishDate: isPaymentDateFilter ? null : `${saleFinishDate} 23:59:59`,
      InitDate:      isPaymentDateFilter ? initDate : null,
      FinishDate:    isPaymentDateFilter && finishDate ? `${finishDate} 23:59:59` : null,
      Brand:         filter?.bandeira?.length ? [filter.bandeira] : null,
      ProductName:   filter?.tipoPagamento?.length ? filter.tipoPagamento : null,
      StatusPagamento: filter?.statusPagamento?.length ? filter.statusPagamento : null,
      BusinessName:  filter?.businessName?.length   ? filter.businessName   : null,
      AcquirerNsu:   filter?.acquirerNsu?.length     ? filter.acquirerNsu    : null,
      Acquirer:      filter?.acquirer != null && filter.acquirer !== -1 ? filter.acquirer : null,
      Capture:       filter?.capture?.length ? filter.capture : null,
      MerchantId:    this.selectedCompany?.merchantId
                       ?? (filter?.merchantId?.length ? filter.merchantId : null),
      OrderNumber:   filter?.orderNumber?.length     ? filter.orderNumber   : null,
      // Escopo do usuário comercial/white label é resolvido no backend pelo e-mail.
      // Aqui só enviamos a hierarquia quando o operador a seleciona manualmente no filtro.
      CommercialHierId: filter?.commercialHierId ? Number(filter.commercialHierId) : null,
      CancellationStatus: filter?.cancellationStatus ?? null,
      SerialNumber:  filter?.serialNumber?.length    ? filter.serialNumber  : null,
      ParcelMin:     filter?.parcelMin ?? null,
      ParcelMax:     filter?.parcelMax ?? null,
      ValueFilter:   buildValueFilter(filter),
      Valori:        true,
      Email:         this.commercialUserEmail,
      UserType:      this.userInfo?.userType ?? null,
    };
  }

  getRecebiveis = async (
    page: number,
    pageSize: number,
    filter?: PainelVendasFilterProps,
    sortBy?: string
  ) => {
    return bffApi.post(`/api/flux/v1/receivables/query-paged`, {
      ...this.buildReceivablePayload(filter, sortBy),
      PageNumber: page,
      PageSize: pageSize,
    });
  }

  downloadRecebiveis = async (
    type: string,
    filter?: PainelVendasFilterProps,
  ) => {
    await executeFluxDownload(
      `/api/flux/v1/receivables/download`,
      this.buildReceivablePayload(filter),
      'PainelDeRecebiveis',
      type
    );
  }

  downloadRecebiveisOfx = async (filter?: PainelVendasFilterProps) => {
    const merchantId = this.selectedCompany?.merchantId;
    const businessId = this.selectedCompany?.id;

    if (!businessId || !merchantId) {
      console.error('BusinessId ou MerchantId não encontrado');
      return;
    }

    const today = getDefaultDate();
    const isPaymentDate = filter?.dateFilterType === DateFilterType.PAIMENTDATE;

    const payload = {
      SortBy: 'desc',
      DateFilterType: filter?.dateFilterType,
      InitDate:      isPaymentDate ? (filter?.saleInitialDate || null) : null,
      FinishDate:    isPaymentDate && filter?.saleFinalDate ? `${filter.saleFinalDate} 23:59:59` : null,
      SaleInitDate:  !isPaymentDate ? (filter?.initialDate || today) : null,
      SaleFinishDate: !isPaymentDate ? `${filter?.finalDate || today} 23:59:59` : null,
      TipoPagamento: filter?.tipoPagamento || null,
      Bandeira:      filter?.bandeira || null,
      StatusPagamento: filter?.statusPagamento || null,
      BusinessName:  filter?.businessName || null,
      AcquirerNsu:   filter?.acquirerNsu || null,
      Acquirer:      filter?.acquirer !== -1 ? filter?.acquirer : null,
      MerchantId:    merchantId,
      OrderNumber:   filter?.orderNumber || null,
      CancellationStatus: filter?.cancellationStatus ?? null,
      SerialNumber:  filter?.serialNumber || null,
      CommercialHierId: filter?.commercialHierId ? Number(filter.commercialHierId) : null,
      Paged: false,
      Donwload: true,
      formato: 'ofx',
      Valori: true,
    };

    const result = await axios.post(
      `${config.apiBaseUrl}/transacoes/receivables-ofx`,
      payload,
      {
        params: { businessID: businessId, merchantId },
        headers: { Authorization: `Bearer ${this.legacyAccessToken?.token}` },
        responseType: 'blob',
      }
    );

    const htmlElement = createHTMLElement(result.data);
    downloadFile(htmlElement, 'PainelDeRecebiveis', 'ofx');
  }

  getCommercialOptions = async (): Promise<CommercialOption[]> => {
    const result = await bffApi.get(`/api/struct/v1/outbound/commercial-options`);
    return result.data;
  }
}
